import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AppShell } from "@/components/layout/AppShell";
import { ThemeProvider } from "@/lib/theme";
import { ToastProvider } from "@/hooks/useToast";
import { AuthRedirectWatcher } from "@/lib/auth-redirect";
import Inhabitants from "@/routes/inhabitants";
import Prices from "@/routes/prices";
import Measurements from "@/routes/measurements";
import Settings from "@/routes/settings";
import InvoicingRoot from "@/routes/invoicing";
import Email from "@/routes/email";

export default function App() {
  return (
    <ThemeProvider>
      <ToastProvider>
        <BrowserRouter>
          <AuthRedirectWatcher />
          <Routes>
            <Route element={<AppShell />}>
              <Route index element={<Navigate to="/invoicing" replace />} />
              <Route path="/inhabitants" element={<Inhabitants />} />
              <Route path="/prices" element={<Prices />} />
              <Route path="/measurements" element={<Measurements />} />
              <Route path="/invoicing" element={<InvoicingRoot />} />
              <Route path="/email/:period/:tenant" element={<Email />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="*" element={<Navigate to="/invoicing" replace />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </ToastProvider>
    </ThemeProvider>
  );
}
